// API Configuration
// В продакшене VITE_API_BASE_URL задаётся как "/api" (см. scripts/deploy.sh).
// Здесь мы считаем, что base URL указывает на корень API (без /products, /users и т.п.),
// а конкретные пути описываем ниже без префикса /api, чтобы не получить /api/api/...
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

export const API_ENDPOINTS = {
  // Base: /api -> /api/health
  health: '/health',

  // Categories
  categories: '/categories',

  // Products
  products: '/products',
  product: (id: string) => `/products/${id}`,
  productSpecifications: (id: string) => `/products/${id}/specifications`,
  productBatch: '/products/batch',

  // Sellers
  seller: (id: string) => `/sellers/${id}`,

  // Users
  users: (id: string) => `/users/${id}`,
  userCreate: '/users',
  userUpdate: (id: string) => `/users/${id}`,
  userByPhone: (phone: string) => `/users/by-phone/${phone}`,
  userOrders: (id: string) => `/users/${id}/orders`,

  // Favorites
  userFavorites: (id: string) => `/users/${id}/favorites`,
  userFavoritesAdd: (id: string) => `/users/${id}/favorites`,
  userFavoritesRemove: (id: string, productId: string) => `/users/${id}/favorites/${productId}`,

  // Cart
  userCart: (id: string) => `/users/${id}/cart`,
  userCartAdd: (id: string) => `/users/${id}/cart`,
  userCartUpdate: (id: string, productId: string) => `/users/${id}/cart/${productId}`,
  userCartRemove: (id: string, productId: string) => `/users/${id}/cart/${productId}`,
} as const;
